export const UPDATE_ORDER = "orderInProgress/UPDATE_ORDER";
export const PLACE_ORDER = "orderInProgress/PLACE_ORDER";
export const PLACE_ORDER_SUCCESS = "orderInProgress/PLACE_ORDER_SUCCESS";
export const PLACE_ORDER_FAIL = "orderInProgress/PLACE_ORDER_FAIL";
export const MARK_AS_CUSTOMER_ARRIVED = "orderInProgress/MARK_AS_CUSTOMER_ARRIVED";
export const MARK_AS_CUSTOMER_ARRIVED_SUCCESS = "orderInProgress/MARK_AS_CUSTOMER_ARRIVED_SUCCESS";
export const MARK_AS_CUSTOMER_ARRIVED_FAIL = "orderInProgress/MARK_AS_CUSTOMER_ARRIVED_FAIL";
